export default async ({
  id = ''
}) => {
  const [content, error, status] = await POST(URLS.kpi.projAppraise.createProjAppraiseAISession, {
    id
  });
  if (error) return {
    error,
    status
  };
  return content || {
    sessionId: '',
    project: '',
    attachments: [],
    'appraise-table': ''
  };
};